import Auth from "../../api/auth";
import { parsePhoneNumberFromString } from "libphonenumber-js/max";
import jsPDF from "jspdf";
import "jspdf-autotable";
import isEqual from "lodash.isequal";
import Moment from "moment";
import { extendMoment } from "moment-range";
import _ from "lodash";
import {
  setDiaryHeader,
  setPlan,
  setDiaryTopContent,
  setDiaryBottomContent,
  getMonthlyItems,
} from "../print/printSections/diary";
import {
  setHouseVisitHeader,
  setHouseVisitContent,
} from "../print/printSections/houseVisit";
import enMessages from "../../languageProvider/locales/en_US.json";

import {
  getSalaryAutoTableData,
  setSalaryHeader,
} from "../print/printSections/salary";
const moment = extendMoment(Moment);
var flatten = require("flat");
var unflatten = require("flat").unflatten;
const SUMMARY_EXCLUSION_KEYWORDS = [
  "day",
  "month",
  "year",
  "name_by_id",
  "clientId",
  "localIdNumber",
  "staff_worker_in_charge_name_by_id",
  "proffesional_name_by_id",
  "employeeId",
  "salaryBranchId",
  "tariffId",
  "revahaAuthorityId",
  "nursingHomeId",
  "age",
  "tariff",
  "organizationBranchNumber",
  "ratio",
  "percentage",
  "expiration",
  "employmentLicenseNumber",
  "commitmentNumber",
  "referenceNumber",
  "serialNumber",
  "lineNumber",
  "missingHoursReason",
  "btlErrorCode",
  "symbolType",
  "baseRate",
];

const getFormItemLabel = (intl, category, name, dynamicFieldName) => {
  const intlId = dynamicFieldName
    ? "app.forms." + category + "." + dynamicFieldName
    : "app.forms." + category + "." + name;
  const label = intl.formatMessage({
    id: intlId,
  });
  return label;
};

const getFormItemVaidation = (intl, label, arr) => {
  const requiredMessage =
    label +
    " " +
    intl.formatMessage({
      id: "app.forms.requiredMessage",
    });

  const emailMessage = intl.formatMessage({
    id: "app.forms.emailMessage",
  });

  const idMessage = intl.formatMessage({
    id: "app.forms.idMessage",
  });

  const postalMessage = intl.formatMessage({
    id: "app.forms.postalMessage",
  });

  const passportMessage = intl.formatMessage({
    id: "app.forms.passportMessage",
  });

  const englishMessage = intl.formatMessage({
    id: "app.forms.englishMessage",
  });

  const onlyNumbersMessage = intl.formatMessage({
    id: "app.forms.onlyNumbersMessage",
  });

  const onlyDigitsMessage = intl.formatMessage({
    id: "app.forms.onlyDigitsMessage",
  });
  const oneTo999Message = intl.formatMessage({
    id: "app.forms.oneTo999Message",
  });

  const oneToNineMessage = intl.formatMessage({
    id: "app.forms.oneToNineMessage",
  });

  const oneToNinetyNineMessage = intl.formatMessage({
    id: "app.forms.oneToNinetyNineMessage",
  });

  const zeroToNinetyNineMessage = intl.formatMessage({
    id: "app.forms.zeroToNinetyNineMessage",
  });

  const twoDigitsMessage = intl.formatMessage({
    id: "app.forms.onlytwoDigitsMessage",
  });

  const fifteenCharactersMessage = intl.formatMessage({
    id: "app.forms.onlyfifteenCharactersMessage",
  });

  const onlyPositiveMessage = intl.formatMessage({
    id: "app.forms.onlyPositiveMessage",
  });

  const domainOrIpMessage = intl.formatMessage({
    id: "app.forms.domainOrIpMessageMessage",
  });

  const urlMessage = intl.formatMessage({
    id: "app.forms.urlMessage",
    defaultMessage: "Please enter a valid URL",
  });

  const eightPositiveNumbersMessage = intl.formatMessage({
    id: "app.forms.eightPositiveNumbersMessage",
    defaultMessage: "Please enter exactly 8 positive numbers",
  });

  const ninePositiveNumbersMessage = intl.formatMessage({
    id: "app.forms.ninePositiveNumbersMessage",
    defaultMessage: "Please enter exactly 9 positive numbers",
  });

  const fivePositiveNumbersMessage = intl.formatMessage({
    id: "app.forms.fivePositiveNumbersMessage",
    defaultMessage: "Please enter exactly 5 positive numbers",
  });

  const dayInMonthMessage = intl.formatMessage({
    id: "app.forms.dayInMonthMessage",
    defaultMessage: "Please enter a number between 1 and 31",
  });

  const required = {
    required: true,
    pattern: /^[\s\t\r\n]*\S+/,
    message: requiredMessage,
  };

  const email = {
    pattern:
      /^([-!#-'*+/-9=?A-Z^-~]+(\.[-!#-'*+/-9=?A-Z^-~]+)*|"([]!#-[^-~ \t]|(\\[\t -~]))+")@[0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?(\.[0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?)+$/,
    message: emailMessage,
  };

  const english = {
    pattern: /^[a-zA-Z\s]+$/,
    message: englishMessage,
  };

  const hasWhiteSpace = (s) => s.indexOf(" ") >= 0;

  const id = ({ getFieldValue }) => ({
    validator(rule, value) {
      if (!value) {
        return Promise.resolve();
      }
      let strId = String(value).trim();
      if (
        hasWhiteSpace(String(value)) ||
        strId.length > 9 ||
        (strId.length < 8 && strId.length > 0)
      ) {
        return Promise.reject(idMessage);
      }
      if (strId.length < 9) {
        while (strId.length < 9) strId = "0" + strId;
      }
      let counter = 0,
        rawVal,
        actualVal;
      for (let i = 0; i < strId.length; i++) {
        rawVal = Number(strId[i]) * ((i % 2) + 1);
        actualVal = rawVal > 9 ? rawVal - 9 : rawVal;
        counter += actualVal;
      }
      if (counter % 10 === 0) {
        return Promise.resolve();
      } else {
        return Promise.reject(idMessage);
      }
    },
  });

  const onlyPositiveNumbers = ({ getFieldValue }) => ({
    validator(rule, value) {
      if (!value) {
        return Promise.resolve();
      }
      let number = parseFloat(value);
      if (number >= 0) {
        return Promise.resolve();
      } else {
        return Promise.reject(onlyPositiveMessage);
      }
    },
  });

  const twoDigitsNumbers = ({ getFieldValue }) => ({
    validator(rule, value) {
      if (!value) {
        return Promise.resolve();
      }
      const decimals = value.toString().split(".")[1];
      let number = decimals ? decimals.length : 0;
      if (number <= 2) {
        return Promise.resolve();
      } else {
        return Promise.reject(twoDigitsMessage);
      }
    },
  });

  const fifteenCharacters = ({ getFieldValue }) => ({
    validator(rule, value) {
      if (!value) {
        return Promise.resolve();
      }
      let number = value.length;
      if (number <= 15) {
        return Promise.resolve();
      } else {
        return Promise.reject(fifteenCharactersMessage);
      }
    },
  });

  const domainOrIp = ({ getFieldValue }) => ({
    validator(rule, value) {
      if (!value) {
        return Promise.resolve();
      }
      if (
        /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
          value
        ) ||
        /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/.test(
          value
        )
      ) {
        return Promise.resolve();
      } else {
        return Promise.reject(domainOrIpMessage);
      }
    },
  });

  const postalCode = {
    pattern: /^[0-9]{5}([0-9]{2})?$/,
    message: postalMessage,
  };

  const passport = {
    pattern: /^(?!^0+$)[a-zA-Z0-9]{6,9}$/,
    message: passportMessage,
  };

  const onlyNumbers = {
    pattern: /^[1-9]\d*(\.\d+)?$/,
    message: onlyNumbersMessage,
  };

  const onlyDigits = {
    pattern: /^[0-9]\d*(\.\d+)?$/,
    message: onlyDigitsMessage,
  };

  const oneTo999Numbers = {
    pattern: /^([1-9]|[1-9][0-9]|[1-9][0-9][0-9])$/,
    message: oneTo999Message,
  };
  const oneToNineNumbers = {
    pattern: /^[1-9]$/,
    message: oneToNineMessage,
  };
  const oneToNinetyNineNumbers = {
    pattern: /^(0?[1-9]|[1-9][0-9])$/,
    message: oneToNinetyNineMessage,
  };
  const zeroToNinetyNineNumbers = {
    pattern: /^[1-9]?\d$/,
    message: zeroToNinetyNineMessage,
  };

  const eightPositiveNumbers = {
    pattern: /^[1-9][0-9]{7}$/,
    message: eightPositiveNumbersMessage,
  };
  const ninePositiveNumbers = {
    pattern: /^[1-9][0-9]{0,8}$/,
    message: ninePositiveNumbersMessage,
  };

  const fivePositiveNumbers = {
    pattern: /^[1-9][0-9]{4}$/,
    message: fivePositiveNumbersMessage,
  };

  const dayInMonth = {
    pattern: /^(0?[1-9]|[1-2][0-9]|3[0-1])$/,
    message: dayInMonthMessage,
  };

  const url = {
    // Allows both http:// and https:// protocols, including internal hostnames without TLD
    pattern: /^(https?:\/\/)?([\da-z.-]+)(\.([a-z.]{2,6}))?([\/\w ._-]*)*\/?$/i,
    message: urlMessage,
  };

  const definedrules = {
    required: required,
    email: email,
    english: english,
    id: id,
    postalCode: postalCode,
    passport: passport,
    onlyNumbers: onlyNumbers,
    onlyDigits: onlyDigits,
    twoDigitsNumbers: twoDigitsNumbers,
    fifteenCharacters: fifteenCharacters,
    domainOrIp: domainOrIp,
    oneTo999Numbers: oneTo999Numbers,
    oneToNineNumbers: oneToNineNumbers,
    oneToNinetyNineNumbers: oneToNinetyNineNumbers,
    zeroToNinetyNineNumbers: zeroToNinetyNineNumbers,
    onlyPositiveNumbers: onlyPositiveNumbers,
    ninePositiveNumbers: ninePositiveNumbers,
    eightPositiveNumbers: eightPositiveNumbers,
    fivePositiveNumbers: fivePositiveNumbers,
    dayInMonth: dayInMonth,
    url: url,
  };
  let rules = [];

  arr.forEach(function (rull) {
    rules.push(definedrules[rull]);
  });

  return rules;
};

const getLocalPhoneNumber = (phone) => {
  const phoneNumber = phone ? parsePhoneNumberFromString(phone) : null;
  if (phoneNumber) {
    return phoneNumber.formatNational();
  }
  return phone;
};

const getWeekday = (day) => {
  return moment.weekdays(+day);
};

const getTranslatedValue = (item, intl) => {
  return intl.formatMessage({
    id: `app.analytics.values.${getAnalyticsValue(item)}`,
    defaultMessage:
      item === null || item === "" ? " " : `${replaceBraces(item)}`,
  });
};

const getChangedItems = (
  changedValues,
  allValues,
  changedItems,
  activeEmployee
) => {
  const key = Object.keys(changedValues)[0];
  const initial = flatten(activeEmployee, {
    safe: true,
  });
  var newChangedItems = changedItems.filter((name) => name !== key);
  let isEqualArray = false;
  if (Array.isArray(initial[key])) {
    const initialArray = initial[key].map(({ key, ...keepAttrs }) => keepAttrs);
    const newArray = changedValues[key].map(
      ({ key, ...keepAttrs }) => keepAttrs
    );
    isEqualArray = isEqual(initialArray, newArray);
  }
  if (
    changedValues[key] !== initial[key] &&
    !isEqualArray &&
    !(changedValues[key] === "" && initial[key] === null)
  ) {
    newChangedItems.push(key);
  }
  return newChangedItems;
};

const getFormChanges = (values, changedItems) => {
  let changes = {};
  changedItems.forEach((item, i) => (changes[item] = values[item]));
  return changes;
};

const isVisStateChanged = (activeReport, visSatate) => {
  const isSame =
    _.isEqual(activeReport.chartType, visSatate.chartType) &&
    _.isEqual(activeReport.pivotConfig, visSatate.pivotConfig) &&
    _.isEqual(activeReport.query, visSatate.query);
  return !isSame;
};

const convertPlanEventFromCalender = (item) => {
  const converted = { ...item };
  let end = item["end"];
  if (
    moment(item["end"]) >
    moment(item["end"]).endOf("day").subtract(1, "minutes")
  ) {
    end = moment(item["end"])
      .set({
        second: "00",
      })
      .toDate();
  }

  const day = moment(item["start"]).get("day");
  const minutes = moment(item["start"]).minutes();
  const hours = moment(item["start"]).hours();
  const minutesFromMiddnight = hours * 60 + minutes;
  var dif = end - item["start"];
  var duration = Math.round(dif / 1000 / 60);
  converted["id"] = item["id"];
  converted["order"] = item["order"];
  converted["order_id"] = item["order"] ? item["order"].id : null;
  converted["employee"] = item["employee"];
  converted["employee_id"] = item["employee"] ? item["employee"].id : null;
  converted["tariff_id"] = item["tariff_id"];
  converted["client_tariff_id"] = item["client_tariff_id"];
  converted["client_tariff"] = item["client_tariff"];
  converted["created_at"] = item["created_at"];
  converted["tariff"] = item["tariff"];
  converted["updated_at"] = item["updated_at"];
  converted["transportation_cost"] = item["transportation_cost"];
  converted["start"] = moment.utc(item["start"]).toDate();
  converted["end"] = moment.utc(end).toDate();
  converted["weekday"] = day;
  converted["duplicateWeekdays"] = item["duplicateWeekdays"];
  converted["start_time_minutes"] = minutesFromMiddnight;
  converted["duration_minutes"] = duration;
  return converted;
};

const convertPlanEventsToCalender = (events) => {
  let final = [];
  events.forEach(function (item) {
    var startOfWeek = moment().startOf("week");
    const day = startOfWeek.add(item.weekday, "days");
    const startDate = day.set("minute", item.start_time_minutes);
    const start = startDate.toDate();
    const end = startDate.add(item.duration_minutes, "minutes").toDate();
    const converted = { ...item, start, end };
    final.push(converted);
  });
  return final;
};

const convertAvailabilityEventsFromCalender = (events, entityId) => {
  let final = [];
  events.forEach(function (item) {
    const converted = {};
    const day = item["start"].getDay();
    const minutes = moment(item["start"]).minutes();
    const hours = moment(item["start"]).hours();
    const minutesFromMiddnight = hours * 60 + minutes;
    var dif = item["end"] - item["start"];
    var duration = Math.round(dif / 1000 / 60);
    converted["place"] = item["place"];
    converted["description"] = item["description"];
    converted["day_of_week"] = day;
    converted["start_time_minutes"] = minutesFromMiddnight;
    converted["duration_minutes"] = duration;
    converted["employee_id"] = entityId;
    converted["id"] = item["id"];
    final.push(converted);
  });
  return final;
};

const convertAvailabilityEventsToCalender = (events) => {
  let final = [];
  events.forEach(function (item) {
    var startOfWeek = moment().startOf("week");
    const day = startOfWeek.add(item.day_of_week, "days");
    const startDate = day.set("minute", item.start_time_minutes);
    const start = startDate.toDate();
    const end = startDate.add(item.duration_minutes, "minutes").toDate();
    const title = item.place;
    const converted = { ...item, start, end, title };
    final.push(converted);
  });
  return final;
};

const comparePlanWithSilmulation = (plan, server) => {
  if (plan && server) {
    const p = {};

    p["patient"] = plan["patient"];
    p["recurrent_events"] = [];
    plan.recurrent_events.forEach((item, i) => {
      p["recurrent_events"].push({
        duration_minutes: item.duration_minutes,
        employee: item.employee_id,
        order: item.order_id,
        start_time_minutes: item.start_time_minutes,
        weekday: item.weekday,
        tariff_id: item.tariff_id,
        client_tariff_id: item.client_tariff_id,
        transportation_cost: item.transportation_cost,
      });
    });

    const s = {};

    s["patient"] = server["patient"];
    s["recurrent_events"] = [];
    server.recurrent_events.forEach((item, i) => {
      s["recurrent_events"].push({
        duration_minutes: item.duration_minutes,
        employee: item.employee_id,
        order: item.order_id,
        start_time_minutes: item.start_time_minutes,
        weekday: item.weekday,
        tariff_id: item.tariff_id,
        client_tariff_id: item.client_tariff_id,
        transportation_cost: item.transportation_cost,
      });
    });
    const a = JSON.stringify(p);
    const b = JSON.stringify(s);
    return a === b;
  }
  return true;
};

const comparePlanEvents = (server, plan) => {
  let oldItems = [];
  server.forEach((s, i) => {
    plan.forEach((a, i) => {
      if (s.id === a.id) {
        const newItem = _.omit(a, ["start", "end"]);
        oldItems.push(newItem);
      }
    });
  });
  const newItems = plan.filter(
    ({ id: id1 }) => !oldItems.some(({ id: id2 }) => id2 === id1)
  );

  const newScheduling = newItems.filter((item) => item.employee_id);
  return _.isEqual(server, oldItems) && newScheduling.length === 0;
};

const shouldGeneratePlanEvents = (server, plan) => {
  let generate = false;
  const serverGrouped = _.groupBy(server.recurrent_events, "order_id");
  const activeGrouped = _.groupBy(plan.recurrent_events, "order_id");
  Object.keys(serverGrouped).map((key, i) => {
    const isEqual =
      serverGrouped[key] && activeGrouped[key]
        ? comparePlanEvents(serverGrouped[key], activeGrouped[key])
        : false;
    const scheduledServerEvents = serverGrouped[key].filter(
      (event) => event.employee_id !== null
    );
    const scheduledActiveEvents = activeGrouped[key]
      ? activeGrouped[key].filter((event) => event.employee_id !== null)
      : [];
    if (
      !isEqual &&
      (scheduledServerEvents.length > 0 || scheduledActiveEvents.length > 0)
    ) {
      generate = true;
    }
  });

  Object.keys(activeGrouped).map((key, i) => {
    const isEqual =
      serverGrouped[key] && activeGrouped[key]
        ? comparePlanEvents(serverGrouped[key], activeGrouped[key])
        : false;
    const scheduledServerEvents = serverGrouped[key]
      ? serverGrouped[key].filter((event) => event.employee_id !== null)
      : [];
    const scheduledActiveEvents = activeGrouped[key].filter(
      (event) => event.employee_id !== null
    );
    if (
      !isEqual &&
      (scheduledServerEvents.length > 0 || scheduledActiveEvents.length > 0)
    ) {
      generate = true;
    }
  });
  return generate;
};

const isNotAvailablePlanEventHours = (
  employee,
  activePatient,
  start,
  end,
  message,
  intl
) => {
  const employeeHours = employee ? employee.non_available_hours : [];
  const patientHours = activePatient.non_available_hours;
  const isEmployeeNotAvailable = isOnNonAvailableHours(
    employeeHours,
    start,
    end
  );
  const isPatientNotAvailable = isOnNonAvailableHours(patientHours, start, end);
  if (isPatientNotAvailable) {
    message.error(
      intl.formatMessage({
        id: "app.plans.patientNotAvailable",
      })
    );
  } else if (isEmployeeNotAvailable) {
    message.error(
      intl.formatMessage({
        id: "app.plans.employeeNotAvailable",
      })
    );
  }
  return isEmployeeNotAvailable || isPatientNotAvailable;
};

const isOnNonAvailableHours = (hours, start, end) => {
  let isOverLapping = false;
  if (hours && hours.length > 0) {
    hours.forEach((item, i) => {
      var startOfWeek = moment().startOf("week");
      const day = startOfWeek.add(item.day_of_week, "days");
      const startDate = day.set("minute", item.start_time_minutes);
      const nonAvailableStart = startDate.toDate();
      const nonAvailableEnd = startDate
        .add(item.duration_minutes, "minutes")
        .toDate();
      const range1 = moment.range(nonAvailableStart, nonAvailableEnd);
      const range2 = moment.range(start, end);
      if (range1.overlaps(range2, { adjacent: false })) {
        isOverLapping = true;
      }
    });
  }
  return isOverLapping;
};

const convertSchedulingEventsToCalender = (events) => {
  let final = [];
  if (events) {
    events.forEach(function (item) {
      const startDate = moment(item.date);
      const start = startDate.toDate();
      const end = startDate.add(item.duration_minutes, "minutes").toDate();
      const title = item["employee"]
        ? item["employee"].surename + " " + item["employee"].first_name
        : "";
      const converted = { ...item, start, end, title };
      final.push(converted);
    });
  }
  return final;
};

const convertSchedulingEventsFromCalender = (item) => {
  const converted = { ...item };
  var dif = item["end"] - item["start"];
  var duration = Math.round(dif / 1000 / 60);
  converted["deleted"] = item["id"];
  converted["date"] = moment.utc(item["start"]);
  converted["duration_minutes"] = duration;
  return converted;
};

const isAllowedOverlapping = (overlappedEvents) => {
  let isAllowed = true;
  overlappedEvents.forEach((a, i) => {
    var startOfWeek = moment().startOf("week");
    const day = startOfWeek.add(a.day_of_week, "days");
    const startDate = day.set("minute", a.start_time_minutes);
    const start = startDate.toDate();
    const end = startDate.add(a.duration_minutes, "minutes").toDate();
    overlappedEvents.forEach((b, j) => {
      if (a.order_id !== b.order_id) {
        var secondStartOfWeek = moment().startOf("week");
        const secondDay = secondStartOfWeek.add(b.day_of_week, "days");
        const secondStartDate = secondDay.set("minute", b.start_time_minutes);
        const secondStart = secondStartDate.toDate();
        const secondEnd = secondStartDate
          .add(b.duration_minutes, "minutes")
          .toDate();
        const range1 = moment.range(start, end);
        const range2 = moment.range(secondStart, secondEnd);
        if (range1.overlaps(range2, { adjacent: false })) {
          isAllowed = false;
        }
      }
    });
  });
  return isAllowed;
};

const isSchedulingAllowedOverlapping = (
  recurrent_events,
  event,
  start,
  end
) => {
  let isAllowed = true;
  // const filtered = recurrent_events.filter((i) => i.id !== event.id);
  // filtered.forEach((item, i) => {
  //   const range1 = moment.range(item.start, item.end);
  //   const range2 = moment.range(start, end);
  //   if (
  //     range1.overlaps(range2, { adjacent: false }) &&
  //     item.employee_id === event.employee_id
  //   ) {
  //     isAllowed = false;
  //   }
  // });
  return isAllowed;
};

const isLoadingHours = (recurrent_events, event, start, end) => {
  let isLoading = false;
  const filtered = recurrent_events.filter((i) => i.id !== event.id);
  filtered.forEach((item, i) => {
    const range1 = moment.range(item.start, item.end);
    const range2 = moment.range(start, end);
    if (
      range1.overlaps(range2, { adjacent: false }) &&
      item.order_id === event.order_id
    ) {
      isLoading = true;
    }
  });
  return isLoading;
};

const getItemsWithHeaders = (items, activeSorter, intl) => {
  if (activeSorter) {
    let sorted = [];
    const withWeekOfMonth = items
      .filter((i) => !i.titleRow)
      .map((r) => ({
        ...r,
        weekNum: weekOfMonth(moment(r.start)) - 1,
      }));

    if (activeSorter !== "start") {
      const groupedBySorter = withWeekOfMonth
        .filter((i) => !i.titleRow)
        .reduce((acc, record) => {
          const sortKey =
            activeSorter === "employee"
              ? record?.is_day_center
                ? intl.formatMessage({
                    id: `app.scheduling.day_center`,
                  })
                : getFullName(
                    record?.employee?.surename,
                    record?.employee?.first_name
                  )
              : activeSorter === "order"
              ? getFullName(
                  record.order.patient.surename,
                  record.order.patient.first_name
                )
              : activeSorter === "client_name"
              ? record.client_name
              : "";
          if (!acc[sortKey]) {
            acc[sortKey] = [];
          }
          acc[sortKey].push(record);
          return acc;
        }, {});

      Object.keys(groupedBySorter).map((sortedKey, k) => {
        let grouped = [...groupedBySorter[sortedKey]];
        const title =
          (activeSorter === "employee" ||
            activeSorter === "order" ||
            activeSorter === "client_name") &&
          !groupedBySorter[sortedKey][0].absenceRow
            ? sortedKey
            : intl.formatMessage({
                id: `app.scheduling.table.absences`,
              });
        const titleItem = {
          ...groupedBySorter[sortedKey][0],
          title,
          id: grouped.reduce((n, { id }) => n + id, 0) + 1,
          start: moment(groupedBySorter[sortedKey][0].start).startOf("month"),
          titleRow: true,
          mainTitle: true,
        };
        grouped.unshift({
          ...titleItem,
        });

        const itemsWithWeekHeaders = getItemsWithWeekHeaders(
          grouped,
          intl,
          title
        );
        sorted = [...sorted, ...itemsWithWeekHeaders];
      });
    } else {
      const itemsWithWeekHeaders = getItemsWithWeekHeaders(
        withWeekOfMonth,
        intl,
        "date"
      );
      sorted = [...sorted, ...itemsWithWeekHeaders];
    }
    return sorted;
  } else if (items) {
    return items.filter((i) => !i.titleRow);
  }
};

const getItemsWithNotScheduledDays = (items, currentDate) => {
  let days = moment(currentDate).daysInMonth();
  let i = 0;
  let daysInMonth = [];
  do {
    i++;
    daysInMonth.push(i);
  } while (i < days);
  let notScheduled = [];
  const scheduledDates = items.map((i) => new Date(i.start).getDate());
  daysInMonth.forEach((day) => {
    if (scheduledDates.includes(day)) {
      return;
    }
    const start = moment(currentDate)
      .startOf("month")
      .add(day - 1, "days")
      .toDate();
    notScheduled.push({
      start,
      absenceRow: true,
      employee: {
        first_name: "",
        surename: "",
      },
      order: {
        id: 0,
        patient: { first_name: "", surename: "" },
      },
      client_name: "",
    });
  });

  // return [...items, ...notScheduled];
  return items;
};

const weekOfMonth = (inputDate) => {
  const date = moment(inputDate);
  const firstDayOfMonth = date.clone().startOf("month");
  let firstSunday = firstDayOfMonth.clone();

  // If the first day of the month is not Sunday, find the previous Sunday
  if (firstDayOfMonth.day() !== 0) {
    firstSunday.subtract(firstDayOfMonth.day(), "days");
  }

  // Calculate the difference in days and determine the week number
  const diffInDays = date.diff(firstSunday, "days");
  return Math.floor(diffInDays / 7) + 1;
};

const getItemsWithWeekHeaders = (arr, intl, title) => {
  let final = [];
  const titleRow = arr.filter((i) => i.mainTitle)[0];
  const grouped = arr
    .filter((i) => !i.mainTitle)
    .reduce((acc, record) => {
      const sortKey = record.weekNum;
      if (!acc[sortKey]) {
        acc[sortKey] = [];
      }
      acc[sortKey].push(record);
      return acc;
    }, {});

  Object.keys(grouped).map((sortedKey, k) => {
    let sortedArray = grouped[sortedKey].sort(
      (a, b) => a["start"].valueOf() - b["start"].valueOf()
    );
    final.push({
      ...grouped[sortedKey][0],
      title: intl.formatMessage({
        id: `app.scheduling.table.weekNumber${sortedKey}`,
      }),
      id: `key-${sortedKey}-${title}`,
      start: moment(sortedArray[0].start).subtract(1, "seconds"),
      titleRow: true,
    });
    return grouped[sortedKey].forEach((record) => final.push(record));
  });
  if (titleRow) {
    final.unshift(titleRow);
  }
  return final;
};

const getEventsWithAbsences = (events, abcenses, currentDate) => {
  let filtered = [];
  if (abcenses && abcenses.length > 0) {
    abcenses.forEach((item, i) => {
      const startOfMonth = moment(currentDate).startOf("month");
      const endOfMonth = moment(currentDate).endOf("month");
      const range1 = moment.range(startOfMonth, endOfMonth);
      const range2 = moment.range(
        moment(item.effective_from),
        moment(item.effective_to)
      );
      if (range1.overlaps(range2, { adjacent: true })) {
        const dates = getDatesInRange(
          item.effective_from,
          item.effective_to,
          startOfMonth.format(),
          endOfMonth.format()
        );
        if (dates.length > 0) {
          dates.forEach((date, j) => {
            filtered.push({
              id: 10000000000 * (i + 3) + j + 1,
              start: moment(date).startOf("day"),
              absenceRow: true,
              reason_id: item.reason_id,
              order: {
                id: filtered.reduce((n, { id }) => n + id, 0),
                patient: {
                  first_name: "",
                  surename: "",
                },
              },
              employee: { id: 64, first_name: "", surename: "" },
              client_name: "",
            });
          });
        }
      }
    });
  }
  const final =
    events && events.length > 0
      ? [...events.filter((i) => !i.absenceRow), ...filtered]
      : filtered;
  return final;
};

const getDatesInRange = (start, end, startOfMonth, endOfMonth) => {
  const date = new Date(start);
  const endDate = new Date(end);
  const dates = [];

  while (date <= endDate) {
    if (moment(date).isBetween(startOfMonth, endOfMonth, undefined, "[]")) {
      dates.push(new Date(date));
    }
    date.setDate(date.getDate() + 1);
  }
  return dates;
};

const getAutoTableData = (data, intl, category) => {
  let columns = [];
  if (data[0]) {
    Object.keys(data[0]).forEach((key) =>
      columns.push({
        header: intl.formatMessage({
          id:
            category === "analytics"
              ? `app.analytics.${
                  key.split(".").length - 1 > 1
                    ? key.substr(0, key.lastIndexOf("."))
                    : key
                }`
              : `app.print.${category}.${key}`,
          defaultMessage: `${key}`,
        }),
        dataKey: key,
      })
    );
  }
  return {
    columns: columns,
    body: data,

    headStyles: {
      fillColor: "#464646",
    },
    alternateRowStyles: {
      fillColor: "#FAFAFA",
    },
  };
};

const getExcelheaders = (data, annotation, intl, category) => {
  let columns = [];
  const isEmpty = _.isEmpty(annotation.timeDimensions);
  let timeDimensionKey = null;
  if (!isEmpty) {
    timeDimensionKey = Object.keys(annotation.timeDimensions)[0];
  }
  Object.keys(data[0]).forEach((key) =>
    columns.push({
      label: intl.formatMessage({
        id:
          category === "analytics"
            ? `app.analytics.${
                key === timeDimensionKey
                  ? timeDimensionKey.substr(
                      0,
                      timeDimensionKey.lastIndexOf(".")
                    )
                  : key
              }`
            : `app.print.${category}.${key}`,
        defaultMessage: `${key}`,
      }),
      key: key,
    })
  );
  columns = columns.reverse();
  return columns;
};

const getExcelData = (data, headers, report) => {
  const exceldata = data.map((item) => {
    let temp = {};
    headers.forEach((header, i) => {
      if (
        typeof item[header.key] === "string" ||
        item[header.key] instanceof String
      ) {
        temp[header.key] = item[header.key].replaceAll('"', '""');
      } else {
        temp[header.key] = item[header.key];
      }
    });
    return temp;
  });

  return exceldata;
};

const getSalaryData = (data, organizationSalarySymbols, intl) => {
  let final = [];
  if (data && data.length > 0) {
    final = data.map((item) => {
      const gender =
        item.gender_id === 1
          ? intl.formatMessage({
              id: "app.dataSelect.gender_id.male",
            })
          : item.gender_id === 2
          ? intl.formatMessage({
              id: "app.dataSelect.gender_id.female",
            })
          : "";

      const employee_type =
        item.employee && item.employee_type_id === 1
          ? intl.formatMessage({
              id: "app.dataSelect.employee_type_id.israel_citizen",
            })
          : item.employee && item.employee_type_id === 2
          ? intl.formatMessage({
              id: "app.dataSelect.employee_type_id.foreign_citizen",
            })
          : item.employee && item.employee_type_id === 3
          ? intl.formatMessage({
              id: "app.dataSelect.employee_type_id.territories_citizen",
            })
          : "";

      const idOrPassport =
        item.employee && item.employee_type_id === 1
          ? item.local_id
          : item.foreign_passport_number;

      const exported = item.exported_to_finance
        ? intl.formatMessage({
            id: "app.forms.yes",
          })
        : intl.formatMessage({
            id: "app.forms.no",
          });

      const approve = item.approved
        ? intl.formatMessage({
            id: "app.forms.yes",
          })
        : intl.formatMessage({
            id: "app.forms.no",
          });

      let newItem = {
        employeeName: getFullName(item.surename, item.first_name),
        accounting_number: item.accounting_number,
        gender_id: gender,
        employee_type,
        idOrPassport,
        age: getAge(item.birthday),
        transportation_cost: item.transportation_cost,
        scheduled_minutes: getHours(item.scheduled_minutes),
        approved_minutes: getHours(item.approved_minutes),
        retro_minutes: getHours(item.retro_minutes),
        total_working_days: item.total_working_days,
        holiday_minutes: getHours(item.holiday_minutes),
        regular_minutes: getHours(item.regular_minutes),
        extra_minutes_rate1: getHours(item.extra_minutes_rate1),
        extra_minutes_rate2: getHours(item.extra_minutes_rate2),
      };
      if (organizationSalarySymbols && organizationSalarySymbols.length > 0) {
        organizationSalarySymbols.forEach((symbol, i) => {
          newItem[`symbol${symbol}`] =
            item.totals_by_symbol && item.totals_by_symbol[symbol]
              ? item.totals_by_symbol[symbol]
              : 0;
        });
      }

      newItem = { ...newItem, exported_to_finance: exported, approve };

      return newItem;
    });
  }

  return final;
};

const getSalaryExcelheaders = (
  data,
  intl,
  organizationSalarySymbols,
  salary_column_settings
) => {
  let columns = [];
  Object.keys(data[0]).forEach((key) => {
    let column = {};
    var check = key.includes("symbol");
    if (check) {
      const symbol_id = +key.split("symbol")[1];
      const symbol = salary_column_settings.filter(
        (i) => i.symbol_id === symbol_id
      )[0];
      column = {
        label: `${symbol.display_name} (${symbol.symbol.symbol})`,
        key,
      };
    } else {
      column = {
        label: intl.formatMessage({
          id: `app.salary.${key}`,
          defaultMessage: `${key}`,
        }),
        key,
      };
    }
    columns.push(column);
  });
  return columns;
};

const getAge = (d) => {
  var today = new Date();
  var birthDate = new Date(d);
  var result = today.getFullYear() - birthDate.getFullYear();
  var m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    result--;
  }
  return result;
};

const getHours = (h) => {
  return Math.round((h / 60) * 100) / 100;
};

const exportReportToPdf = (
  fileName,
  tableData,
  setHeader,
  headerRecord,
  setTopContent,
  setBottomContent,
  bottomContentRecord,
  setFooter,
  marginTop,
  intl,
  category,
  rest,
  orientation,
  action
) => {
  const doc = new jsPDF({ orientation: orientation ? orientation : "p" });
  doc.setR2L(true);
  const support_totals = headerRecord?.support_totals;
  if (setTopContent) {
    setTopContent(doc);
  }
  const table = {
    ...getAutoTableData(tableData, intl, category),
    didDrawPage: function (data) {
      // Header
      if (setHeader) {
        setHeader(doc, headerRecord);
      }
    },
    didParseCell: function (data) {
      const isHebrew = (text) => {
        return text.search(/[\u0590-\u05FF]/) >= 0;
      };
      if (!isHebrew(data.cell.text[0])) {
        data.cell.text = data.cell.text[0].split("").reverse().join("");
      }

      // Style the summary row if it's the last row and support_totals is true
      if (support_totals && data.row.index === tableData.length - 1) {
        data.cell.styles.fontStyle = "bold";
        data.cell.styles.fillColor = [240, 240, 240]; // Light gray background
      }
    },
    ...rest,
    styles: {
      ...rest.styles,
      font: "Rubik",
      halign: "right",
      overflow: "linebreak",
    },
  };

  doc.autoTable(table);
  if (setBottomContent) {
    setBottomContent(
      doc,
      bottomContentRecord,
      headerRecord,
      setHeader,
      headerRecord
    );
  }
  if (setFooter && setFooter !== "paging") {
    setFooter(doc);
  } else if (setFooter === "paging") {
    addFooter(doc);
  }
  return action === "print"
    ? window.open(doc.output("bloburl"), "_blank")
    : doc.save(`${fileName}-${moment().format("HH:mm DD/MM/YYYY")}.pdf`);
};

const exportEmergencyBtlToPdf = (
  fileName,
  tableData,
  headers,
  setHeader,
  headerRecord,
  rest,
  action
) => {
  const doc = new jsPDF({ orientation: "l" });
  doc.setR2L(true);
  let columns = headers.reverse().map((h) => {
    return {
      header: h,
      dataKey: h,
    };
  });
  const autoTableData = {
    columns: columns,
    body: tableData,
    headStyles: {
      fillColor: "#464646",
    },
    alternateRowStyles: {
      fillColor: "#FAFAFA",
    },
  };

  const table = {
    ...autoTableData,
    didDrawPage: function (data) {
      // Header
      if (setHeader) {
        setHeader(doc, headerRecord);
      }
    },
    didParseCell: function (data) {
      const isHebrew = (text) => {
        return text.search(/[\u0590-\u05FF]/) >= 0;
      };
      if (!isHebrew(data.cell.text[0])) {
        data.cell.text = data.cell.text[0].split("").reverse().join("");
      }
    },
    ...rest,
    styles: {
      ...rest.styles,
      font: "Rubik",
      halign: "right",
      // cellWidth: "wrap",
      overflow: "linebreak",
    },
  };

  doc.autoTable(table);
  addFooter(doc);
  return action === "print"
    ? window.open(doc.output("bloburl"), "_blank")
    : doc.save(`${fileName}-${moment().format("HH:mm DD/MM/YYYY")}.pdf`);
};

const exportSalaryToPdf = (
  tableData,
  columns,
  headerRecord,
  rest,
  orientation
) => {
  const doc = new jsPDF({ orientation: orientation ? orientation : "p" });
  doc.setR2L(true);
  const table = {
    ...getSalaryAutoTableData(tableData, columns),
    didDrawPage: function (data) {
      // Header
      setSalaryHeader(doc, headerRecord);
    },
    didParseCell: function (data) {
      const isHebrew = (text) => {
        return text.search(/[\u0590-\u05FF]/) >= 0;
      };
      if (!isHebrew(data.cell.text[0])) {
        data.cell.text = data.cell.text[0].split("").reverse().join("");
      }
    },
    ...rest,
    styles: {
      ...rest.styles,
      font: "Rubik",
      halign: "right",
      // cellWidth: "wrap",
      overflow: "linebreak",
    },
  };

  doc.autoTable(table);

  return window.open(doc.output("bloburl"), "_blank");
};

const getReportPdf = (
  fileName,
  tableData,
  setHeader,
  headerRecord,
  setTopContent,
  setBottomContent,
  bottomContentRecord,
  setFooter,
  marginTop,
  intl,
  category,
  rest,
  orientation,
  doc
) => {
  doc.setR2L(true);

  if (setTopContent) {
    setTopContent(doc);
  }
  const table = {
    ...getAutoTableData(tableData, intl, category),
    didDrawPage: function (data) {
      // Header
      if (setHeader) {
        setHeader(doc, headerRecord);
      }
    },
    didParseCell: function (data) {
      const isHebrew = (text) => {
        return text.search(/[\u0590-\u05FF]/) >= 0;
      };
      if (!isHebrew(data.cell.text[0])) {
        data.cell.text = data.cell.text[0].split("").reverse().join("");
      }
    },
    ...rest,
    styles: {
      ...rest.styles,
      font: "Rubik",
      halign: "right",
      // cellWidth: "wrap",
      overflow: "linebreak",
    },
  };

  doc.autoTable(table);
  if (setBottomContent) {
    setBottomContent(
      doc,
      bottomContentRecord,
      headerRecord,
      setHeader,
      headerRecord
    );
  }
  if (setFooter && setFooter !== "paging") {
    setFooter(doc);
  } else if (setFooter === "paging") {
    addFooter(doc);
  }
  return doc;
};

const getProspectusDoc = (
  prospectuslines,
  activeProspectus,
  doc,
  organization,
  getItems,
  getColumns,
  intl,
  setHeader,
  setBottomContent
) => {
  const isSelfPayments =
    activeProspectus.payments && activeProspectus.payments?.name !== "";
  const items = getItems(prospectuslines, activeProspectus);
  const headerRecord = {
    serial_number: activeProspectus.serial_number,
    year: activeProspectus.year,
    month: activeProspectus.month,
    organizationName: organization.name,
    taxId: organization.tax_id,
    serviceProviderNumber: organization.service_provider_number,
    supporting_community_service_provider_number:
      organization.supporting_community_service_provider_number,
    clientName: activeProspectus.client.name,
    accountingCode:
      activeProspectus["client.accounting_code"] &&
      activeProspectus["client.accounting_code"],
    clientCategoryName: activeProspectus.client.category.name,
    comitteeNumber:
      activeProspectus.client.specific_data &&
      activeProspectus.client.specific_data.comittee_number,
    organizationBranchNumber:
      activeProspectus.client &&
      activeProspectus.client.specific_data &&
      activeProspectus.client.specific_data.organization_branch_number,
    isSocialSecurity:
      activeProspectus.client.social_security &&
      activeProspectus.client.social_security,
    supporting_community: activeProspectus.supporting_community,
    day_center: activeProspectus.day_center,
    chargedAmount: activeProspectus.charged_amount,
    chargedUnits: activeProspectus.charged_units,
    branch: unflatten(activeProspectus, { safe: true }).branch,
    client: activeProspectus.client,
    isSelfPayments,
    is_self_participating: activeProspectus?.is_self_participating,
    paymentsName: activeProspectus.payments && activeProspectus.payments.name,
    paymentsAddress:
      activeProspectus.payments && activeProspectus.payments.address
        ? [
            activeProspectus.payments.address,
            activeProspectus.payments.city,
          ].join(", ")
        : "",
  };
  const columnStyles = getColumns(activeProspectus);
  return getReportPdf(
    intl.formatMessage({
      id: "app.prospectuses.printForecastsFileName",
    }),
    items,
    setHeader,
    headerRecord,
    null,
    setBottomContent,
    items,
    "paging",
    40,
    intl,
    "prospectuses",
    {
      styles: { fontSize: 8.5 },
      columnStyles: columnStyles,
      margin: { top: 39 },
    },
    null,
    doc
  );
};

const addFooter = (doc) => {
  const pageCount = doc.internal.getNumberOfPages();
  doc.setFontSize(10);
  doc.setR2L(true);
  doc.setFont("Rubik", "normal"); // set font
  var pageSize = doc.internal.pageSize;
  var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
  for (var i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.text(
      "עמוד " + String(i) + " מתוך " + String(pageCount),
      20,
      pageHeight - 10,
      {
        align: "center",
      }
    );
  }
};

const createTromFile = async (
  fileName,
  tableData,
  setHeader,
  headerRecord,
  setTopContent,
  setBottomContent,
  bottomContentRecord,
  setFooter,
  marginTop,
  intl,
  category,
  rest,
  orientation,
  action
) => {
  const doc = new jsPDF({ orientation: orientation ? orientation : "p" });
  doc.setR2L(true);
  let topBottomLoc = marginTop;
  if (setTopContent) {
    topBottomLoc = setTopContent(doc, headerRecord);
  }
  // Wait for the header to be set before creating the table
  if (setHeader) {
    await setHeader(doc, headerRecord);
  }
  const table = {
    ...getAutoTableData(tableData, intl, category),
    didParseCell: function (data) {
      const isHebrew = (text) => {
        return text.search(/[\u0590-\u05FF]/) >= 0;
      };
      if (!isHebrew(data.cell.text[0])) {
        data.cell.text = data.cell.text[0].split("").reverse().join("");
      }
    },
    ...rest,
    styles: {
      // ...rest.styles,
      font: "Rubik",
      halign: "right",
      // cellWidth: "wrap",
      overflow: "linebreak",
    },
    startY: topBottomLoc,
  };

  doc.autoTable(table);
  if (setBottomContent) {
    setBottomContent(doc, bottomContentRecord, setHeader, headerRecord, intl);
  }
  if (setFooter && setFooter !== "paging") {
    setFooter(doc);
  } else if (setFooter === "paging") {
    addFooter(doc);
  }
  return doc;
};

const getDiary = (doc, intl, record, organization, currentDate, logo) => {
  const branch = record?.patient?.branch;
  const planEvents = record.recurrent_work_events;
  const rest_day = record?.rest_day;
  const manualEvents = _.sortBy(record.manual_events, [
    function (o) {
      return o.date;
    },
  ]);
  const allEvents = _.sortBy(
    [...record.manual_events, ...record.scheduled_recurrent_events],
    [
      function (o) {
        return o.date;
      },
    ]
  );
  const totalMinutes = allEvents.reduce(
    (sum, event) => sum + event.duration_minutes,
    0
  );
  const totalHours = totalMinutes / 60;
  const isHolocast = record?.order?.client?.category?.holocast_fund;
  const isForeignWorker =
    record?.employee?.employee_type_id === 2 &&
    !record?.employee?.tourist_with_license;

  const shouldRenderHours = isHolocast && isForeignWorker;

  const tableData = getMonthlyItems(
    record.holidays,
    currentDate,
    shouldRenderHours,
    allEvents
  );
  const headerRecord = {
    organization,
    branch,
    record,
    currentDate,
    patient: {
      ...record.patient,
    },
    rest_day,
    logo,
    totalHours,
  };
  const footerRecord = {
    organization,
  };

  let columnStyles = {
    0: { cellWidth: 27 },
    1: { cellWidth: 27 },
    2: { cellWidth: 21 },
    3: { cellWidth: 21 },
    4: { cellWidth: 21 },
    5: { cellWidth: 21 },
    6: { cellWidth: 21 },
    7: { cellWidth: 7 },
    8: { cellWidth: 10 },
    9: { cellWidth: 5.77 },
  };
  const pdf = createDiary(
    doc,
    intl.formatMessage({
      id: "app.prospectuses.printForecastsFileName",
    }),
    planEvents,
    manualEvents,
    setPlan,
    tableData,
    setDiaryHeader,
    headerRecord,
    setDiaryTopContent,
    setDiaryBottomContent,
    footerRecord,
    "paging",
    94,
    intl,
    "diary",
    {
      columnStyles: columnStyles,
    },
    "p",
    "print"
  );
  return pdf;
};

const createDiary = (
  doc,
  fileName,
  planEvents,
  manualEvents,
  setPlan,
  tableData,
  setHeader,
  headerRecord,
  setTopContent,
  setBottomContent,
  bottomContentRecord,
  setFooter,
  marginTop,
  intl,
  category,
  rest,
  orientation,
  action
) => {
  doc.setR2L(true);
  setPlan(intl, doc, planEvents, manualEvents);
  const table = {
    ...getAutoTableData(tableData, intl, category),
    didDrawPage: function (data) {
      // Top content
      setHeader(intl, doc, headerRecord);
      setTopContent(doc, headerRecord, intl);
    },
    didParseCell: function (data) {
      const rest_day = headerRecord?.rest_day ?? 6;
      if (
        data.column.index !== 0 &&
        data.row.section !== "head" &&
        (data.row.raw.day.content === moment.weekdays(rest_day) ??
          data.row.raw.holiday.content !== "")
      ) {
        data.cell.styles.fillColor = ["#d9d9d9"];
      }

      if (
        (data.column.index === 2 ||
          data.column.index === 3 ||
          data.column.index === 4 ||
          data.column.index === 5 ||
          data.column.index === 6 ||
          data.column.index === 7) &&
        data.row.section !== "head"
      ) {
        data.cell.styles.fontStyle = "bold";
      }
      const isHebrew = (text) => {
        return text.search(/[\u0590-\u05FF]/) >= 0;
      };
      if (!isHebrew(data.cell.text[0])) {
        data.cell.text = data.cell.text[0].split("").reverse().join("");
      }
    },
    ...rest,
    styles: {
      fontSize: 9,
      font: "Rubik",
      halign: "right",
      // cellWidth: "wrap",
      overflow: "linebreak",
      lineColor: [40],
      lineWidth: 0.3,
      cellPadding: 0.5,
    },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: 40,
    },
    startY: doc.lastAutoTable.finalY + 2,
    theme: "grid",
  };
  doc.autoTable(table);
  if (setBottomContent) {
    setBottomContent(doc, bottomContentRecord, setHeader, headerRecord, intl);
  }
  return doc;
};

export const getHouseVisit = (
  doc,
  intl,
  record,
  userBranches,
  organization,
  logo,
  approvalImg,
  verifyImg
) => {
  const branch = userBranches.filter((i) => i.id === record.patient.branch)[0];
  const headerRecord = {
    organization,
    branch,
    record,
    patient: {
      ...record.patient,
    },
    logo,
  };
  setHouseVisitHeader(intl, doc, headerRecord);
  setHouseVisitContent(doc, headerRecord, intl, approvalImg, verifyImg);
  return doc;
};

const getAgeByDate = (date) => {
  var today = new Date();
  var birthDate = new Date(date);
  var result = today.getFullYear() - birthDate.getFullYear();
  var m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    result--;
  }
  return result;
};

const getActiveOrders = (current, orders) => {
  let activeOrders = [];
  if (orders) {
    orders.forEach((item, i) => {
      if (
        (item.effective_to &&
          moment(current).within(
            moment.range(
              moment(item.effective_from).startOf("day"),
              moment(item.effective_to).endOf("day")
            )
          )) ||
        (!item.effective_to &&
          !moment(current).isBefore(moment(item.effective_from).startOf("day")))
      ) {
        activeOrders.push(item);
      }
    });
  }
  return activeOrders;
};

const openURL = (url) => {
  var downloadLink = document.createElement("a");
  downloadLink.href = url;
  downloadLink.download = "test";
  downloadLink.title = "Download";
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
};

const getFullName = (surename, firstName) => {
  return `${surename} ${firstName}`;
};

const getAddress = (record) => {
  const street =
    record && record.street !== undefined
      ? record.street.trim() + " " + record.house_number
      : "";
  const address =
    record && record.city !== undefined
      ? record.city.trim() + ", " + street
      : street;
  return address;
};

const getProffesionalName = (record, intl) => {
  let employeeName = getFullName(record.surename, record.first_name);
  if (record.professional_role_id) {
    const role =
      record.professional_role_id &&
      intl.formatMessage({
        id: `app.dataSelect.professional_role_id.${record.professional_role_id}`,
      });
    employeeName = employeeName.concat(", ", role);
  }
  return employeeName;
};

const getShortProffesionalName = (record, intl) => {
  let employeeName = record.first_name;
  if (record.professional_role_id) {
    const role =
      record.professional_role_id &&
      intl.formatMessage({
        id: `app.dataSelect.professional_role_id.${record.professional_role_id}`,
      });
    employeeName = employeeName.concat(", ", role);
  }
  return employeeName;
};

const getProffesionalTitle = (record, intl) => {
  let title = "";
  if (record.professional_role_id) {
    const role =
      record.professional_role_id &&
      intl.formatMessage({
        id: `app.dataSelect.professional_role_id.${record.professional_role_id}`,
      });
    title = role;
  }
  return title;
};

const getPdfMargins = (doc) => {
  return 40 / doc.internal.scaleFactor;
};

const loadImage = (src) => {
  return new Promise((resolve, reject) => {
    let img = new Image();
    img.src = src;
    img.onload = () => resolve(img);
    img.onerror = (err) => {
      resolve(null);
    };
  });
};

/**
 * Retrieves the internationalized analytics value for a given key. If a corresponding
 * internationalized message exists, it returns the formatted message. Otherwise, it returns
 * the key as is. The function handles strings and booleans.
 *
 * @param {Object} intl - The internationalization object for message formatting.
 * @param {string|boolean} key - The key for which to retrieve the internationalized value.
 * @returns {string} The internationalized message if it exists, otherwise the original key.
 */
const getAnalyticsValue = (intl, key) => {
  // Handle non-string and non-boolean types
  if (typeof key !== "string" && typeof key !== "boolean") {
    return key;
  }

  // Construct the message ID
  const messageId = `app.analytics.values.${key}`;

  // Check if the message ID exists in enMessages and format the message if it does
  const messageExists = messageId in enMessages;
  return messageExists ? intl.formatMessage({ id: messageId }) : key.toString(); // Convert boolean to string if necessary
};

const replaceBraces = (str) => {
  return str && typeof str === "string"
    ? str.replace(/{/g, "(").replace(/}/g, ")")
    : str;
};

const getOrderChangeLogsPdf = (
  orderChangeLogs,
  intl,
  clientName,
  patientName,
  localId,
  maxHours
) => {
  const arr = [];
  orderChangeLogs.forEach((element) => {
    const temp = {
      effective_from_change: moment(element.effective_from).format("L"),
      created_at_hour: moment(element.created_at).format("HH:mm"),
      created_at: moment(element.created_at).format("L"),
      created_by: element.created_by["name"],
    };
    arr.push(temp);
    const nestedData = element.events
      .sort((a, b) => a.start_time_minutes - b.start_time_minutes)
      .sort((a, b) => a.weekday - b.weekday)
      .map((i) => {
        return {
          duration: Math.round((i.duration_minutes / 60) * 100) / 100,
          end_time: moment()
            .startOf("day")
            .set("minute", i.duration_minutes + i.start_time_minutes)
            .format("HH:mm"),
          start_time: moment()
            .startOf("day")
            .set("minute", i.start_time_minutes)
            .format("HH:mm"),
          weekday: moment.weekdays(i.weekday),
          employee:
            i.employee &&
            getFullName(i.employee.surename, i.employee.first_name),
        };
      });
    arr.push({
      effective_from_change: "",
      items: nestedData,
    });
  });
  var doc = new jsPDF();
  var keys = Object.keys(arr[0]);
  const mainColumns = keys.map((j) => {
    return {
      dataKey: j,
      header: intl.formatMessage({
        id: `app.plans.${j}`,
      }),
    };
  });

  doc.setR2L(true);
  setOrderChangeLogsHeader(doc, clientName, patientName, localId, maxHours);
  doc.autoTable({
    theme: "grid",
    columns: mainColumns,
    body: arr,
    startY: 36,
    styles: {
      font: "Rubik",
      halign: "right",
      // cellWidth: "wrap",
      overflow: "linebreak",
    },
    headStyles: {
      fillColor: "#464646",
    },
    alternateRowStyles: {
      fillColor: "#FAFAFA",
    },
    didParseCell: function (data) {
      const isHebrew = (text) => {
        return text.search(/[\u0590-\u05FF]/) >= 0;
      };
      if (!isHebrew(data.cell.text[0])) {
        data.cell.text = data.cell.text[0].split("").reverse().join("");
      }
      if (data.row.raw.effective_from_change === "") {
        data.cell.styles.fillColor = null;
        // data.cell.styles.lineWidth = 0;
      }
      if (
        data.column.dataKey === "effective_from_change" &&
        data.row.raw.effective_from_change === ""
      ) {
        data.cell.colSpan = 4;
        data.cell.styles.minCellHeight =
          7.584 * (data.row.raw.items.length + 1) + 4;
      }
    },
    didDrawCell: function (data) {
      if (
        data.column.dataKey === "effective_from_change" &&
        data.row.raw.effective_from_change === ""
      ) {
        const tableWidth = data.table.columns.reduce((accumulator, object) => {
          return accumulator + object.width;
        }, 0);

        doc.autoTable({
          startY: data.cell.y + 2,
          margin: { left: data.cell.x },
          tableWidth: tableWidth,
          columns: Object.keys(data.row.raw.items[0]).map((j) => {
            return {
              dataKey: j,
              header: intl.formatMessage({
                id: `app.plans.${j}`,
              }),
            };
          }),
          body: data.row.raw.items,
          theme: "plain",
          didParseCell: function (data) {
            const isHebrew = (text) => {
              return text.search(/[\u0590-\u05FF]/) >= 0;
            };
            if (!isHebrew(data.cell.text[0])) {
              data.cell.text = data.cell.text[0].split("").reverse().join("");
            }
          },
          styles: {
            font: "Rubik",
            halign: "right",
            // cellWidth: "wrap",
            overflow: "linebreak",
          },
        });
      }
    },
  });
  return doc;
};

const setOrderChangeLogsHeader = (
  doc,
  clientName,
  patientName,
  localId,
  maxHours
) => {
  doc.setFontSize(16);
  doc.setTextColor(40);
  doc.setR2L(true);
  doc.setFont("Rubik", "normal"); // set font
  var title = "שינויי תכנית שבועית";
  const margins = getPdfMargins(doc);
  var hLoc = doc.internal.pageSize.getWidth() - margins;
  var subTitle = clientName;
  const report = "תאריך הדפסה";
  const date = `${moment().format("HH:mm DD/MM/YYYY")}`;
  const reportDate = `${report} - ${date}`;
  const patientDetails = `${patientName}, ${localId}`;
  const maxHoursDetails = maxHours
    ? `סה״כ שעות שבועיות: ${maxHours.toString()}`
    : "";
  doc.text(title, hLoc, 20, {
    align: "right",
  });
  doc.setFontSize(12);
  doc.text(subTitle, hLoc, 26, {
    align: "right",
  });
  doc.text(reportDate, margins, 20, {
    align: "left",
  });
  doc.setFontSize(11);

  doc.text(`${patientDetails} | ${maxHoursDetails}`, hLoc, 32, {
    align: "right",
  });
};

const checkDatesBeforeEndOfMonth = (conflictMap, specificOrderId) => {
  const startOfMonth = moment().startOf("month");
  const endOfMonth = moment().endOf("month");

  const relevantOrders = conflictMap[specificOrderId] || [];

  // Filter out orders that have conflict_end_date before the start of the current month
  const currentMonthOrders = relevantOrders.filter((order) =>
    moment(order.conflict_end_date).isSameOrAfter(startOfMonth)
  );

  const validDates = currentMonthOrders.every((order) =>
    moment(order.conflict_end_date).isSameOrBefore(endOfMonth)
  );

  if (validDates && currentMonthOrders.length) {
    const latestDate = currentMonthOrders.reduce((latest, current) =>
      moment(latest.conflict_end_date).isAfter(current.conflict_end_date)
        ? latest
        : current
    );

    return latestDate.conflict_end_date;
  }

  return null;
};

const calculateTableSummaryRow = (columns, dataSource) => {
  const summaryRow = {};

  columns.forEach((column) => {
    if (column.type === "number") {
      // Check if column name contains any exclusion keyword
      const shouldExclude = SUMMARY_EXCLUSION_KEYWORDS.some((keyword) =>
        column.key.toLowerCase().includes(keyword.toLowerCase())
      );

      if (!shouldExclude) {
        const sum = dataSource.reduce((acc, row) => {
          const value = parseFloat(row[column.key]) || 0;
          return acc + value;
        }, 0);
        summaryRow[column.key] = Number.isInteger(sum)
          ? sum.toString()
          : sum.toFixed(2);
      }
    }
  });

  return summaryRow;
};

export {
  getFormItemLabel,
  getFormItemVaidation,
  getLocalPhoneNumber,
  getWeekday,
  getTranslatedValue,
  getChangedItems,
  getFormChanges,
  isVisStateChanged,
  convertPlanEventFromCalender,
  convertPlanEventsToCalender,
  convertAvailabilityEventsFromCalender,
  convertAvailabilityEventsToCalender,
  comparePlanWithSilmulation,
  comparePlanEvents,
  shouldGeneratePlanEvents,
  isNotAvailablePlanEventHours,
  isSchedulingAllowedOverlapping,
  isLoadingHours,
  getItemsWithHeaders,
  getItemsWithNotScheduledDays,
  getEventsWithAbsences,
  isAllowedOverlapping,
  convertSchedulingEventsToCalender,
  convertSchedulingEventsFromCalender,
  getAutoTableData,
  getExcelheaders,
  getExcelData,
  getSalaryData,
  getSalaryExcelheaders,
  exportReportToPdf,
  exportEmergencyBtlToPdf,
  exportSalaryToPdf,
  getReportPdf,
  getProspectusDoc,
  createTromFile,
  getDiary,
  createDiary,
  getAgeByDate,
  getActiveOrders,
  openURL,
  getFullName,
  getAddress,
  getProffesionalName,
  getShortProffesionalName,
  getProffesionalTitle,
  getPdfMargins,
  loadImage,
  getAnalyticsValue,
  replaceBraces,
  getOrderChangeLogsPdf,
  checkDatesBeforeEndOfMonth,
  calculateTableSummaryRow,
};
